import * as yup from 'yup';

export const newFvValidate = yup.object({
  paymentTo: yup.string(),
  createdAt: yup.date(),
  number: yup.string().required('Numer FV jest wymagany'),
});
